import React from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import CustomScrollbars from 'util/CustomScrollbars';
import SidebarLogo from './SidebarLogo';
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from '../../constants/ThemeSetting';
import IntlMessages from '../../util/IntlMessages';
import {
  MERCHANT_ACCOUNTS,
  TRANSACTIONS,
  USERS,
  TRANSACTION_SETTLEMENTS,
  FDS_CARDS, SETTLEMENT_REPORTS, PROCESSING_SUMMARIES,
  PERMISSIONS, ROLES,
  EVENTS,
  QUEUEMESSAGES,
  GATEWAY_TRANSACTIONS,
  GATEWAY_CALLBACKS,
  GATEWAY_SUSPECIOUS_ACTIVITIES,
  DATA_TRAFFIC_WEBSITES
} from '../../constants/resources';
import { userSignOut } from "../../redux/actions";
import PermissionMenu from "./PermissionMenu";
import AdminMenu from './AdminMenu';
import PermissionGroupMenu from './PermissionGroupMenu';

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const { pathname } = useSelector(({ common }) => common);

  const getNoHeaderClass = (style) => {
    if (style === NAV_STYLE_NO_HEADER_MINI_SIDEBAR
      || style === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return 'gx-no-header-notifications';
    }
    return '';
  };

  const getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split('/')[1];
  const dispatch = useDispatch();

  const { SubMenu } = Menu;
  const MenuItemGroup = Menu.ItemGroup;

  return (
    <>
      <SidebarLogo sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} />
      <div className="gx-sidebar-content">
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline"
          >
            <MenuItemGroup
              key="main"
              className="gx-menu-group"
              popupClassName={getNavStyleSubMenuClass(navStyle)}
              title={<IntlMessages id="sidebar.main" />}>
              <PermissionMenu key="AllTransactions" resource={TRANSACTIONS}>
                <Link to="/transactions">
                  <i className="icon icon-timeline" />
                  <span>Transactions</span>
                </Link>
              </PermissionMenu>
              <PermissionMenu key="merchant-account" resource={MERCHANT_ACCOUNTS}>
                <Link to="/merchant-accounts">
                  <i className="icon icon-modal" />
                  <span>Business Accounts</span>
                </Link>
              </PermissionMenu>
              <PermissionMenu key="merchant-settlements" resource={TRANSACTION_SETTLEMENTS}>
                <Link to="/merchant-settlements">
                  <i className="icon icon-pricing-table" />
                  <span>Settlements</span>
                </Link>
              </PermissionMenu>
              {/* <PermissionMenu key="processors" resource={PROCESSORS}>
                <Link to="/processors">
                  <i className="icon icon-culture-calendar" />
                  <span>Acquirers MIDs</span>
                </Link>
              </PermissionMenu> */}
              <PermissionMenu key="settlement-reports" resource={SETTLEMENT_REPORTS}>
                <Link to="/settlement-reports">
                  <i className="icon icon-files" />
                  <span>Settlement Reports</span>
                </Link>
              </PermissionMenu>
              {/* <PermissionMenu key="transaction_charges" resource={TRANSACTION_CHARGES}>
                <Link to="/transaction_charges">
                  <i className="icon icon-table-data"/>
                  <span>MID Charges</span>
                </Link>
              </PermissionMenu> */}
              <PermissionMenu key="processing-summaries" resource={PROCESSING_SUMMARIES}>
                <Link to="/processing_summaries">
                  <i className="icon icon-chat" />
                  <span>Processing Summaries</span>
                </Link>
              </PermissionMenu>
              {/* <PricingPlanMenu> */}
              {/* </PricingPlanMenu> */}
            </MenuItemGroup>

            <PermissionGroupMenu
              resource={EVENTS}
              key="processing"
              className="gx-menu-group"
              popupClassName={getNavStyleSubMenuClass(navStyle)}
              title={<IntlMessages id="sidebar.processing" />}>
              {/*<Menu.Item key="main/dashboard/crypto">*/}
              {/*  <Link to="/main/dashboard/crypto">*/}
              {/*    <i className="icon icon-crypto"/>*/}
              {/*    <span><IntlMessages id="sidebar.dashboard.crypto"/></span>*/}
              {/*  </Link>*/}
              {/*</Menu.Item>*/}
              <PermissionMenu key="events-summaries" resource={EVENTS}>
                <Link to="/events">
                  <i className="icon icon-calendar" />
                  <span><IntlMessages id="sidebar.events" /></span>
                </Link>
              </PermissionMenu>
              <Menu.Item key="timelines">
                <Link to="/timelines">
                  <i className="icon icon-timeline" />
                  <span><IntlMessages id="sidebar.timelines" /></span>
                </Link>
              </Menu.Item>
              <PermissionMenu key="queue-messages" resource={QUEUEMESSAGES}>
                <Link to="/queue-messages">
                  <i className="icon icon-ripple" />
                  <span>Queue Messages</span>
                </Link>
              </PermissionMenu>
              <PermissionMenu key="gateway-transactions" resource={GATEWAY_TRANSACTIONS}>
                <Link to="/gateway-transactions">
                  <i className="icon icon-anchor" />
                  <span><IntlMessages id="sidebar.transactions" /></span>
                </Link>
              </PermissionMenu>
              <PermissionMenu key="gateway-callbacks" resource={GATEWAY_CALLBACKS}>
                <Link to="/gateway-callbacks">
                  <i className="icon icon-callout" />
                  <span>Callbacks</span>
                </Link>
              </PermissionMenu>
              <PermissionMenu key="gateway-suspicious-logs" resource={GATEWAY_SUSPECIOUS_ACTIVITIES}>
                <Link to="/gateway-suspicious-logs">
                  <i className="icon icon-eye" />
                  <span>Suspicious</span>
                </Link>
              </PermissionMenu>
              <AdminMenu key="gateway-ipns" resource={USERS}>
                <Link to="/gateway-ipns">
                  <i className="icon icon-link" />
                  <span>IPNs</span>
                </Link>
              </AdminMenu>
            </PermissionGroupMenu>
            <PermissionGroupMenu key="fds-menu-group"
              resource={FDS_CARDS}
              className="gx-menu-group"
              popupClassName={getNavStyleSubMenuClass(navStyle)}
              title={<IntlMessages id="sidebar.fds" />}>
              <PermissionMenu key="fds-cards" resource={FDS_CARDS}>
                <Link to="/fds-cards">
                  <i className="icon icon-card" />
                  <span>Cards</span>
                </Link>
              </PermissionMenu>
              <PermissionMenu key="websites-cards" resource={DATA_TRAFFIC_WEBSITES}>
                <Link to="/traffic-websites">
                  <i className="icon icon-map-km-layer" />
                  <span>Traffic Websites</span>
                </Link>
              </PermissionMenu>
            </PermissionGroupMenu>
            <MenuItemGroup
              key="main"
              className="gx-menu-group"
              popupClassName={getNavStyleSubMenuClass(navStyle)}
              title={<IntlMessages id="sidebar.auth" />}>
              <PermissionMenu key="users" resource={USERS}>
                <Link to="/users">
                  <i className="icon icon-auth-screen" />
                  <span><IntlMessages id="sidebar.users" /></span>
                </Link>
              </PermissionMenu>
              <AdminMenu key="roles" resource={ROLES}>
                <Link to="/roles">
                  <i className="icon icon-visits" />
                  <span><IntlMessages id="sidebar.roles" /></span>
                </Link>
              </AdminMenu>
              <AdminMenu key="permissions" resource={PERMISSIONS}>
                <Link to="/permissions">
                  <i className="icon icon-refer" />
                  <span><IntlMessages id="sidebar.permissions" /></span>
                </Link>
              </AdminMenu>
              <Menu.Item key="profile">
                <Link to="/profile">
                  <i className="icon icon-profile" />
                  <span>Profile</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="logout">
                <Link to="" onClick={() => dispatch(userSignOut())}>
                  <i className="icon icon-close" />
                  <span>Sign Out</span>
                </Link>
              </Menu.Item>
            </MenuItemGroup>
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

SidebarContent.propTypes = {
  sidebarCollapsed: PropTypes.bool.isRequired,
  setSidebarCollapsed: PropTypes.func.isRequired,
};

export default SidebarContent;
